import assets from '../v1/assets';
import pages from '../v3/pages';
import schedules from '../v1/schedules';
import shows from '../v1/shows';
import stations from './stations';
import vod from '../v1/vod';
import entities from '../v1/entities';

export default function v4(backendAxiosInstance) {
  return {
    ...assets(backendAxiosInstance),
    ...pages(backendAxiosInstance),
    ...schedules(backendAxiosInstance),
    ...shows(backendAxiosInstance),
    ...stations(backendAxiosInstance),
    ...vod(backendAxiosInstance),
    ...entities(backendAxiosInstance),
  };
}
